import React, { useEffect, useRef, useState } from 'react';
import './menuitem.css'
/**
 * MenuItem component that displays a button with an image and expands to show children when clicked.
 * These component's are managed by the parent Menu component.
 * the only things this is concerned with is the button image, the ID of the item, and the children to display when expanded.
 * It will handle the click but just callback the parent (props.onActivate)
 * @param {string} props.ID - Unique identifier for the menu item. 
 * @param {string} props.activeID - The ID of the currently active menu item.
 * @param {function} props.onActivate - Function to call when the menu item is activated.
 * @param {string} props.buttonImage - URL of the image to display on the button.
 * @param {boolean} props.disabled - Whether the menu item is disabled.
 * @param {React.ReactNode} props.children - The content to display when the menu item is expanded.
 * @returns {JSX.Element} The rendered MenuItem component.
 */
const MenuItem = ({ ID, activeID, onActivate, buttonImage, disabled, children, centered=false }) => {
    const [ expanded, setExpanded ] = useState(false);
    const [ innerHeight, setInnerHeight ] = useState(null);
    const childRef = useRef(null);
    const imgRef = useRef(null);

    // Animation time / init
    //const [ animationTime, setAnimationTime ] = useState('0ms');
    useEffect(()=>{
        const height = childRef.current.firstChild.clientHeight + 6;
        setInnerHeight(`${height}px`);
    }, [childRef]);
    
    // Parent selected lookup when the id changes
    useEffect(()=>{
        setExpanded( ID===activeID );
    }, [ID, activeID]);

    function handleMenuClick(){
        if (disabled) return;
        onActivate( ID );
    }

    function handleMouseLeave(){
        if (expanded){
           onActivate( null );
        }
    }

    return ( <div 
        className='item-container'
        id={ID}
        onMouseLeave={handleMouseLeave}
        style={{ zIndex: (expanded ? 100 : 2) }}
    >
        <div
            className='item-button'
            alt={`${ID} button`}
            onClick={handleMenuClick}         
            ref={imgRef}
            style={{ opacity: disabled ? 0.5 : 1, '--bg': `url('${buttonImage}')` }}
        ></div>
        <div 
            className={'item-child-container'}
            /* className={centered ? `item-child-container-centered` : 'item-child-container'} */
            ref={childRef}
            style={{ maxHeight: (expanded ? innerHeight : '0px') }}
        >{ children }</div>
    </div> );
};
export default MenuItem;